<template>
  <Modal :title="'Thumbnail'" :classStr="'max-w-6xl'" v-model="isModalOpen" :handleClose="onclickCancel">
    <div class="">
      <div class="border-b border-gray-200 mb-4">
        <nav class="-mb-px flex space-x-8">
          <button
            type="button"
            class="border-green-light whitespace-nowrap py-4 px-1 font-medium text-sm"
            :class="{
              'text-green-light border-b-2': currentNav == 1,
            }"
            @click="onclickNavButton(1)"
          >
            Choose from the Library
          </button>
          <button
            type="button"
            class="border-green-light whitespace-nowrap py-4 px-1 font-medium text-sm"
            :class="{
              'text-green-light border-b-2': currentNav == 2,
            }"
            @click="onclickNavButton(2)"
          >
           Upload from your System
          </button>
        </nav>
      </div>
      <div class="h-96 overflow-auto" v-if="currentNav == 1">
        <div class="relative text-gray-700 mb-4 m-1">
          <input
            class="w-full h-10 pl-3 pr-8 border-1 border-borderColor text-base placeholder-gray-600 rounded-lg focus:outline-none ring-1"
            type="search"
            placeholder="Search.."
            v-model="search"
          />
          <button
            type="button"
            class="absolute inset-y-0 right-0 flex items-center px-4 font-bold text-white bg-green-light rounded-r-lg hover:bg-green-light"
            @click="onclickSearch"
          >
            Search
          </button>
        </div>
        <div class="grid grid-cols-6 gap-4" v-if="imagesArr">
          <button
            type="button"
            class="relative max-w-xs overflow-hidden rounded-lg shadow-lg focus:shadow-outline"
            v-for="i in imagesArr"
            :key="i.id"
            @click="onclickImage(i.url)"
          >
            <img
              class="object-cover w-full w-12 h-full"
              :src="i.url"
              alt="Flower and sky"
            />
            <div class="absolute top-0 left-0 px-6 py-4">
              <h4 class="mb-3 text-xl font-semibold tracking-tight text-white">
                <!-- {{ i.id }} -->
              </h4>
            </div>
          </button>
        </div>
        <div class="mt-4">
          <PaginationComponent
            v-if="imagesArr.length"
            :currentPage="pagination.current_page"
            :handlePageChange="handlePageChange"
            :totalPages="pagination.last_page"
          />
        </div>
      </div>
      <div class="h-96" v-if="currentNav == 2">
        <vue2Dropzone
          ref="imgDropZone"
          id="customdropzone"
          :options="dropzoneOptions"
          @vdropzone-complete="handleComplete"
        ></vue2Dropzone>
      </div>
    </div>

    <div class="flex items-center justify-end">
      <button
        type="button"
        class="h-10 px-4 m-2 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:shadow-outline"
        @click="onclickCancel"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
        @click.prevent="onclickSubmit"
      >
        Submit
      </button>
    </div>
  </Modal>
</template>

<script>
import { Modal, PaginationComponent } from "@/components/t-components";
import axios from "axios";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "ThumbnailModal",
  components: {
    Modal,
    vue2Dropzone,
    PaginationComponent,
  },
  props: {
    isModalOpenProp: {
      type: Boolean,
    },
    tabSelection:{
      type: String
    }
  },
  data() {
    return {
      isModalOpen: this.isModalOpenProp,
      currentNav: 1,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        addRemoveLinks: false,
        maxFiles: 4,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class="text-black text-xl">Drop files here or <u class="text-indigo-700">browse files</u></p>
        <p>We support .jpg, .jpeg, .png files</p>`,
      },
      search: "Fitness",
      imagesArr: [],
      currentPage: 1,
      pagination: {},
      file: null,
    };
  },
  computed: {
    ...mapGetters(["images"]),

    imagesSearch() {
      return this.images;
    },
  },
  watch: {
    imagesSearch(images) {
      this.imagesArr = images.data;
    },
  },
  methods: {
    ...mapActions(["getImagesSearch"]),

    async onclickNavButton(val) {
      this.currentNav = val;
      val && val === 1 && this.search && this.search.length ? await this.onclickSearch() : ''
    },

    async handleComplete(upload) {
      //   if (this.supportingImage && this.supportingImage.length > 3) {
      //     alert("You cannot upload anymore files.");
      //     this.$refs.imgDropZone.removeFile(upload);
      //     return;
      //   }
      try {
        this.file = upload;
      } catch (e) {
        console.log(e);
      }
    },

    onclickCancel() {
      this.isModalOpen = false;
      this.$emit("cancelModal", false);
    },

    async onclickSearch() {
      store.commit("setIsLoading", true);
      await this.getImagesSearch(this.search);
      this.imagesArr = this.images && this.images.data;
      this.pagination.current_page = this.images && this.images.current_page;
      this.pagination.last_page = this.images && this.images.total_pages;
      store.commit("setIsLoading", false);
    },

    async handlePageChange(page) {
      store.commit("setIsLoading", true);
      this.currentPage = page;
      this.imagesArr = [];
      axios
        .get(`get/images/${this.search}/15?page=${this.currentPage}`)
        .then((res) => {
          this.imagesArr = res.data.data.data || [];
          this.pagination.current_page = res.data.data.current_page;
          this.pagination.last_page = res.data.data.total_pages;
        })
        .catch((e) => console.log(e));
      store.commit("setIsLoading", false);
    },

    async onclickImage(url) {
      fetch(url)
        .then((r) => r.blob())
        .then((blob) => {
          let file = new File([blob], "filename.jpg", {
            type: blob.type,
          });
          this.file = file;
        })
        .catch((e) => console.log(e));
    },

    onclickSubmit() {
      if (this.file) {
        this.$emit("sessionImage", this.file);
        this.onclickCancel();
      } else {
        const error = {
          title: "Alert",
          text: "Please select a Image",
        };
        this.$store.commit('setError', error)
      }
    },
  },
  async created() {
    if (this.tabSelection && this.tabSelection === 'library') {
      await this.onclickSearch();
    } else {
      this.currentNav = 2
    }
  },
};
</script>

<style scoped>
#customdropzone {
  background-color: white;
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color 0.2s linear;
  height: 360px;
  padding-top: 80px;
  border-radius: 2%;
  border: 2px solid lightgray;
  border-style: dashed;
}
</style>